// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Fm4K"};


//////////////////
// WEBPACK FOOTER
// ./app/components/fluid-avatar-image/fluid-avatar-image.scss
// module id = 827
// module chunks = 3 4 5 6 7